const FALLBACK_ORDER = ['ru', 'en', 'az'] as const;

type LocalizedValue = {
  ru?: string | null;
  en?: string | null;
  az?: string | null;
};

/** Resolve a localized {ru,en,az} value: requested language, then fallbacks. */
export function resolveLocalized(
  value: LocalizedValue,
  language: string,
): string {
  const direct = value[language as keyof LocalizedValue];
  if (direct) return direct;
  for (const fallback of FALLBACK_ORDER) {
    const candidate = value[fallback];
    if (candidate) return candidate;
  }
  return '';
}
